var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldBitcoinConvert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 15.969c0 2.96-2.06 5.44-4.83 6.09l.27-.45a.751.751 0 1 0-1.29-.77l-1.05 1.75c-.14.23-.14.52-.01.75.13.24.38.38.65.38 4.27 0 7.75-3.48 7.75-7.75a.74.74 0 0 0-.74-.75c-.41 0-.75.34-.75.75zM.25 7.969c0 .41.34.75.75.75s.75-.34.75-.75c0-2.96 2.06-5.44 4.83-6.09l-.27.45a.751.751 0 1 0 1.29.77l1.05-1.75c.13-.23.14-.51 0-.75A.752.752 0 0 0 8 .219C3.73.219.25 3.699.25 7.969z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.33 14.76v-.02c-.29-3.73-3.31-6.77-7.09-7.07a6.158 6.158 0 0 1 6.09-5.17c3.41 0 6.17 2.76 6.17 6.17 0 3.08-2.24 5.62-5.17 6.09zM9.43 13.82H7.37v.75h2.06c.21.01.38-.16.38-.37 0-.15-.17-.38-.38-.38zM9.43 16.078H7.37v.75h2.47c.32 0 .54-.2.54-.38s-.23-.37-.55-.37h-.4z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15 9.168c-.16-.01-.31-.02-.48-.02a6.17 6.17 0 0 0-6.17 6.18c0 3.41 2.76 6.17 6.17 6.17s6.18-2.76 6.18-6.17c0-.17-.01-.32-.02-.48a6.174 6.174 0 0 0-5.68-5.68zm.02 9.16v.38c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.38H6.62c-.41 0-.75-.34-.75-.75v-4.5c0-.41.34-.75.75-.75h1.05v-.38c0-.41.34-.75.75-.75s.75.34.75.75v.38h.26c1 0 1.88.88 1.88 1.88 0 .29-.07.56-.19.81.46.34.75.86.75 1.44 0 1.03-.91 1.87-2.04 1.87h-.66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBitcoinConvert);
export default __webpack_public_path__ + "static/media/vuesax-bold-bitcoin-convert.2b8450171b3b47fea379abece1e27d57.svg";
export { ForwardRef as ReactComponent };